<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      
    }
  },
  created() {
    // // check in store is logged in?
    // if(this.$store.getters.isLoggedIn)
    //   this.$router.push('/calendar');
    // // check for cookies
    // if(this.hasCookies())
    //   this.$store.dispatch('validateCookies', this.getCookies())
    //     .then(() => {
    //       this.$router.push('/calendar');
    //     })
    //     .catch();
  }
}
</script>

<style lang="scss">
#app > div > div:nth-child(2) {
  position: absolute;
  top: 52px;
  left: 0;
  right: 0;
}

.overflow-x {
  overflow-x: hidden;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/App.vue